import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0f9b1d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "flex flex-col items-center" }

import { computed } from 'vue'

// Adicionamos 'hideLabels' nas props

export default /*#__PURE__*/_defineComponent({
  __name: 'card',
  props: ['type', 'confirmed', 'notConfirmed', 'doctorPending', 'hideLabels'],
  setup(__props) {

const props = __props;



const cardClass = computed(() => {
  switch (props.type) {
    case 'ABERTO':
      return 'card card-opened'
    case 'FIXO':
      return 'card card-weekly'
    case 'COBERTURA':
      return 'card card-coverage'
    case 'EXTRA':
      return 'card card-extra'
    default:
      return 'card'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { cols: "6" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["card", cardClass.value])
      }, [
        (props.type === 'ABERTO')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Vaga aberta"))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createTextVNode(" Dr Minha Escala "),
              _hoisted_3,
              _createTextVNode("123123-SP ")
            ])),
        _createElementVNode("div", _hoisted_4, [
          (__props.confirmed)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["legend", { 'line-through opacity-50': props.hideLabels }])
              }, " Confirmado ", 2))
            : _createCommentVNode("", true),
          (__props.notConfirmed)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["legend", { 'line-through opacity-50': props.hideLabels }])
              }, " Não confirmado ", 2))
            : _createCommentVNode("", true),
          (__props.doctorPending)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(["legend", { 'line-through opacity-50': props.hideLabels }])
              }, " Pendente ", 2))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})